import { createContext, useContext } from 'react';

/**
 * The facility's IANA time zone. Every clock time on its page is shown in it, as in the emails it gets,
 * so a viewer abroad or on a UTC laptop reads the same time the driver keeps.
 */
export const FacilityTimeZoneContext = createContext<string | null>(null);

export const useFacilityTimeZone = (): string => {
  const timeZone = useContext(FacilityTimeZoneContext);
  if (timeZone == null) {
    throw new Error('useFacilityTimeZone needs FacilityTimeZoneContext from the facility transfer page');
  }
  return timeZone;
};
